import type { DataTableRow } from 'carbon-components-svelte/src/DataTable/DataTable.svelte';

import { rowContainsText } from '../../utils/rowContainsText';

export const applyFilters = (rows: DataTableRow[], filterSelections: Record<string, string[]>): DataTableRow[] =>
  rows.filter((row) =>
    Object.entries(filterSelections).every(
      ([key, values]) => !values.length || values.includes(String((row as Record<string, unknown>)[key]))
    )
  );

export const filterAndSearchRows = (rows: DataTableRow[], filterValues: Record<string, string[]>, searchText: string): DataTableRow[] => {
  const filtered = applyFilters(rows, filterValues);
  return searchText ? filtered.filter((row) => rowContainsText(row, searchText)) : filtered;
};

const sameFilters = (a: Record<string, string[]>, b: Record<string, string[]>): boolean => {
  const keys = Object.keys(a);
  if (keys.length !== Object.keys(b).length) {
    return false;
  }
  return keys.every((key) => {
    const av = a[key];
    const bv = b[key];
    return Array.isArray(av) && Array.isArray(bv) && av.length === bv.length && av.every((value, index) => value === bv[index]);
  });
};

export const createRowPipeline = () => {
  let lastRows: DataTableRow[] | undefined,
    lastFilters: Record<string, string[]> | undefined,
    lastSearch: string | undefined,
    lastResult: DataTableRow[] = [];

  return (rows: DataTableRow[], filterValues: Record<string, string[]>, searchText: string): DataTableRow[] => {
    if (rows === lastRows && searchText === lastSearch && lastFilters && sameFilters(filterValues, lastFilters)) {
      return lastResult;
    }
    lastResult = filterAndSearchRows(rows, filterValues, searchText);
    lastRows = rows;
    lastFilters = filterValues;
    lastSearch = searchText;
    return lastResult;
  };
};
